export enum UploadTaxIncomeStatus {
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  FAILED = "FAILED",
}

export interface UploadTaxIncomeHistoryResponseDto {
  uploadDate: string;
  uploadBy: string;
  fileName: string;
  status: UploadTaxIncomeStatus;
  processed: number;
  totalData: number;
  fileOriginal: string;
  fileError: string;
}

export interface UploadTaxIncomeHistoryParams {
  branchId?: string;
  pphTypeId?: string;
  status?: UploadTaxIncomeStatus;
  page: number;
  limit: number;
}
